import { InfoIcon } from '@assets/icons';
import { Typography } from '@components/typography';
import { Stack, alpha, useTheme } from '@mui/material';
import { ResourceCard } from './ResourceCard';

export const CombinedContextInfoCard = () => {
  const { palette } = useTheme();
  return (
    <ResourceCard
      sx={{
        color: palette.foreground.paper.default,
        borderColor: palette.resource.workspace.border,
        backgroundColor:
          palette.mode === 'dark'
            ? alpha(palette.resource.workspace.background, 0.05)
            : alpha(palette.resource.workspace.background, 0.8),
        '&:hover': {
          borderColor: palette.resource.workspace.border,
        },
      }}
    >
      <Stack
        sx={{
          height: '37px',
          width: '32px',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Stack
          sx={{
            height: '32px',
            width: '32px',
            borderRadius: '50%',
            backgroundColor: palette.resource.workspace.background,
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <InfoIcon size={16} color={palette.resource.workspace.foreground} />
        </Stack>
      </Stack>
      <Stack sx={{ overflow: 'hidden', flex: '1 1 100px', minWidth: '100px' }} gap={1}>
        <Typography variant="body1" sx={{ '&:first-letter': { textTransform: 'capitalize' } }}>
          Combined context info
        </Typography>
        <Typography variant="caption2" color="foreground.paper.light">
          All rule sources are combined in order of precedence (Organization → Workspace → User →
          Service) to create the complete context that is fed to agents operating in a workspace.
        </Typography>
      </Stack>
    </ResourceCard>
  );
};
